var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('topbar'),_vm._v(" "),_c('left'),_vm._v(" "),(_vm.status==0)?_c('signup_result0'):_vm._e(),_vm._v(" "),(_vm.status==1)?_c('signup_result1'):_vm._e(),_vm._v(" "),(_vm.status==2)?_c('signup_result2'):_vm._e(),_vm._v(" "),(_vm.status==3)?_c('signup_result3'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4d28716","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/signup_result.vue
// module id = null
// module chunks = 